import React from 'react';
import { API } from 'aws-amplify';
import { PageHeader } from '@ant-design/pro-layout';
import { Typography, Descriptions, Spin } from 'antd';
import { LeaveDetailsPanel, LeaveSummary } from 'basealpha-ui';
import ContentWrapper from '../../Components/ContentWrapper';
import withAppState, { IAppStateComponentProps } from '../../state/withAppState';
import { Redirect } from 'react-router-dom';

type Props = IAppStateComponentProps & {};
type State = {
  activeContract?: { [key: string]: any } | boolean;
  leaveSummary?: LeaveSummary | null;
};

class Profile extends React.Component<Props, State> {
  state: State = {
    activeContract: undefined,
    leaveSummary: undefined,
  };

  async componentDidMount(): Promise<void> {
    if (!this.props.appState.user.profile) {
      API.get('EhcmsPortalApi', '/me', {}).then((r: any): void => {
        this.props.setAppState('user', r);
      });
    }
    API.get('EhcmsPortalApi', '/contractor/contracts/active', {}).then((r: any): void => {
      this.setState({ activeContract: r || false });
    });
    API.get('EhcmsPortalApi', '/contractor/leaves/summary', {}).then((r: any): void => {
      this.setState({ leaveSummary: r?.leaveSummary ?? null });
    }).catch((): void => {
      this.setState({ leaveSummary: null });
    });
  }

  render(): React.ReactElement {
    const user = this.props.appState?.user;
    const activeContract = (this.state.activeContract || {}) as any;
    if (!user) {
      return <Redirect to="/" />;
    }
    return (
      <div data-testid="profile-page">
        <PageHeader title={user?.profile?.name || ''} />
        <ContentWrapper>
          {this.state.activeContract !== false && (
            <>
              <Typography.Title level={3}>Contract Details</Typography.Title>
              {typeof this.state.activeContract === 'undefined' && <Spin />}
              {activeContract.id && (
                <Descriptions layout="vertical" bordered>
                  <Descriptions.Item label="Employer">{activeContract.customer[1]}</Descriptions.Item>
                  <Descriptions.Item label="Job Title">{activeContract.job_id[1]}</Descriptions.Item>
                </Descriptions>
              )}
            </>
          )}
          <LeaveDetailsPanel leaveSummary={this.state.leaveSummary ?? null} mode="profile" />
        </ContentWrapper>
      </div>
    );
  }
}

export default withAppState(Profile);
